import { render } from "./InspectionInput.vue?vue&type=template&id=4e01ba87"
import script from "./InspectionInput.vue?vue&type=script&lang=js"
export * from "./InspectionInput.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__